function stringIsWhitespace(string) {
  return !string || !string.trim();
}

export default stringIsWhitespace;
